import { ChangeDetectionStrategy, Component, computed, ElementRef, input, output, ViewChild } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { UBaseInfraComponent } from '../u-base-infra.component';
import { UTypeElement } from '../../types';

@Component({
  selector: 'u-toggle-button',
  templateUrl: './u-toggle-button.component.html',
  styleUrl: './u-toggle-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UToggleButtonComponent extends UBaseInfraComponent {
  checked = input.required<boolean>();
  onIcon = input<string>();
  offIcon = input<string>();
  onLabel = input<string>();
  offLabel = input<string>();
  outlined = input<boolean>();
  activeType = input<UTypeElement>('secondary');
  onChange = output<{ originalEvent: HTMLButtonElement; checked: boolean }>();

  @ViewChild('matToggleButton', { read: ElementRef }) matToggleButtonRef: ElementRef;

  currentIcon = computed(() => {
    if (this.checked()) {
      return this.onIcon() ? this.ICON_CLASS + this.onIcon() : null;
    } else {
      return this.offIcon() || this.onIcon() ? this.ICON_CLASS + (this.offIcon() || this.onIcon()) : null;
    }
  });

  currentLabel = computed(() => {
    if (this.checked()) {
      return this.onLabel() || '';
    } else {
      return this.offLabel() || this.onLabel() || '';
    }
  });

  getIconRef() {
    return this.matToggleButtonRef?.nativeElement?.querySelector('.p-button-icon');
  }

  onToggleChange(event: MatButtonToggleChange) {
    this.onChange.emit({
      originalEvent: event.source._buttonElement.nativeElement,
      checked: event.source.checked,
    });
  }

  getBaseClasses() {
    return {
      ...super.getBaseClasses(),
      'u-toggle-button-outlined': this.outlined(),
      'u-active-secondary': this.activeType() === 'secondary',
      'u-active-success': this.activeType() === 'success',
      'p-button-icon-only': this.currentIcon() && !this.currentLabel(),
    };
  }
}
